// dashboard-agent-ia/src/context/AuthContext.js
import React, { createContext, useState, useContext } from 'react'

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem('user')) || null
  )

  const login = (userData) => {
    setUser(userData)
    localStorage.setItem('user', JSON.stringify(userData))
  }

  const logout = () => {
    setUser(null)
    localStorage.removeItem('user')
  }

  const getHomeRoute = () => {
    if (!user) return '/login'
    if (user.role === 'admin') return '/admin-dashboard'
    return '/business-dashboard'
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, getHomeRoute }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
